import { BooleanSelection } from '@src/types/index';

import { SimSettingsFormValues } from './types';

const MAX_CHOSEN_SIMS = 4;

const orderedFormFields = [
  'simPlanId',
  'isKeepNumber',
  'keepNumber',
  'pacNumber',
  'isCancelNumber',
  'cancelNumber',
  'stacNumber',
  'budgetControl',
];

const defaultPortingValues: Omit<
  SimSettingsFormValues,
  'budgetControl' | 'simPlanId'
> = {
  isKeepNumber: BooleanSelection.No,
  keepNumber: '',
  pacNumber: '',
  isCancelNumber: BooleanSelection.No,
  cancelNumber: '',
  stacNumber: '',
};

const defaultValues: SimSettingsFormValues = {
  simPlanId: '',
  budgetControl: BooleanSelection.No,
  ...defaultPortingValues,
};

export {
  MAX_CHOSEN_SIMS,
  orderedFormFields,
  defaultValues,
  defaultPortingValues,
};
